import { render } from "./PortfolioSection.vue?vue&type=template&id=595256c4"
import script from "./PortfolioSection.vue?vue&type=script&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&lang=js"

import "@/styles/Portfolio-Section.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__